import { render, staticRenderFns } from "./onboarding-multitenant.vue?vue&type=template&id=65883785&"
import script from "./onboarding-multitenant.vue?vue&type=script&lang=js&"
export * from "./onboarding-multitenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports